module.exports = __webpack_public_path__ + "static/media/donors-choose.84ba382c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client-logos/donors-choose.png
// module id = 272
// module chunks = 0